<template>
  <div class="fixed inset-0 z-50">
    <ReactLoadingScreen />
  </div>
</template>

<script setup lang="ts">
import { LoadingScreen } from '@sparklayer-io/dashboard';
import { applyPureReactInVue } from 'veaury';
import { reactWrapperOptions } from '@/lib/veaury';

const ReactLoadingScreen = applyPureReactInVue(LoadingScreen, reactWrapperOptions);
</script>
